/* eslint new-cap: 0 */
/* global _satellite isAdyenZppBancontactIntegrationEnabled addAriaLabelToDisabledPaymentMethods */
import utils, {
  isAdobeSatelliteTrackingReady,
  isMyAccount,
  sendAdobeData,
  focusAccessibleAlert,
  trackEvents,
} from '../utils';
import VMasker from 'vanilla-masker';
import { logError, logException } from '../services/sentryService';
import { ApplePayUtils } from '../utils/applepay-utils';
import modal from '../components/modal';

let PAYMENT = {};
let previousPaymentMethod;
let newPaymentMethod;
let previousBankOwnerName;
let newBankOwnerName;
let previousBankIban;
let newBankIban;
let previousCreditCard;

const isEditPaymentPage = window.location.href.includes(
  '/checkout/editpayment'
);

PAYMENT.init = function () {
  selectOnlineBankingIssuerIssuer();
  showHiddenBLZPayment();
  showHiddenSepaPayment();
  disablePaymentMethodsDisabledByBrowser();
  maskIban();
  trackSepaErrors();
  trackInsecurePaymentMethodsMessage();
  showApplePayMessage();

  if (isEditPaymentPage) {
    initPaymentTabs();
    initVkModalForModernisedPayment();
  }

  const fallbackPspStatus =
    document.getElementById('fallbackPspStatus')?.value === 'true';

  if (
    window.location.href.includes('newCreditCardNeeded=true') ||
    window.location.href.includes('creditCardExpired=true') ||
    fallbackPspStatus
  ) {
    showCreditCardActionInfoMessage();
  }

  if (window.location.href.includes('account')) {
    previousPaymentMethod = getElementValue('paymentMethod', '#payment-form');
    if (previousPaymentMethod === 'BS') {
      previousBankOwnerName = getElementValue(
        'bankPayment',
        'bankPayment.ownerName'
      );
      previousBankIban = getElementValue('bankPayment', 'bankPayment.iban');
    }
    if (previousPaymentMethod === 'AK') {
      previousCreditCard = $('.adyen .card__selected').attr('data-number');
    }
  }

  $('#editPaymentSubmit').click(function (e) {
    e.preventDefault();
    const braintreeAccordion = document.getElementById('braintreeCreditCard');
    const adyenAccordion = document.getElementById('adyenCreditCard');

    if (adyenAccordion && adyenAccordion.checked) {
      handleEditPaymentSubmissionForZppAdyen();
    } else if (shouldSaveAdyenBancontactCard()) {
      handleEditPaymentSubmissionForZppBancontactAdyen();
    } else if (braintreeAccordion && braintreeAccordion.checked) {
      handleEditPaymentSubmissionForZppBraintree();
    } else {
      $('form[id=payment-form]').submit();
    }
  });

  const shouldSaveAdyenBancontactCard = () => {
    if (!isAdyenZppBancontactIntegrationEnabled) {
      return false;
    }

    const bancontactAccordion = document.getElementById('bancontact');
    if (!bancontactAccordion || !bancontactAccordion.checked) {
      return false;
    }

    const bancontactCardRadioButton = document.getElementById('bancontactcard');
    return bancontactCardRadioButton && bancontactCardRadioButton.checked;
  };

  $('form[id=payment-form]').on('submit', function () {
    clearMask();
    if (window.location.href.includes('account')) {
      newPaymentMethod = getElementValue('paymentMethod', '#payment-form');
      if (
        (previousPaymentMethod === 'BS' && newPaymentMethod === 'BS') ||
        (previousPaymentMethod === 'AK' && newPaymentMethod === 'AK')
      ) {
        if (newPaymentMethod === 'BS') {
          newBankOwnerName = getElementValue(
            'bankPayment',
            'bankPayment.ownerName'
          );
          newBankIban = getElementValue('bankPayment', 'bankPayment.iban');
          if (
            previousBankOwnerName !== newBankOwnerName ||
            previousBankIban !== newBankIban
          ) {
            trackEvents('change_payment_method', {
              change_payment_method: false,
              new_payment_method: newPaymentMethod,
              change_payment_detail: true,
            });
          }
        } else if (newPaymentMethod === 'AK') {
          let newCreditCard = $('.adyen .card__selected').attr('data-number');
          if (previousCreditCard !== newCreditCard) {
            trackEvents('change_payment_method', {
              change_payment_method: false,
              new_payment_method: newPaymentMethod,
              change_payment_detail: true,
            });
          }
        }
      } else if (newPaymentMethod !== previousPaymentMethod) {
        trackEvents('change_payment_method', {
          change_payment_method: true,
          new_payment_method: newPaymentMethod,
          change_payment_detail: false,
        });
      }
    }
  });

  //  There are issues for older android devices, so we don't activate masking for them.
  let isAndroid = utils.isAndroid();

  let $ibanInput = $('input[name="bankPayment.iban"]');

  if (!isAndroid) {
    $ibanInput.keyup(function () {
      VMasker($(this)).maskPattern('SSSS SSSS SSSS SSSS SSSS SSSS SSSS SSSS');
    });
  } else {
    utils.maxLengthValidator($ibanInput, 32);
  }

  initPrepaymentModalForEditPayment();
  if (window.location.pathname.includes('editpayment')) {
    addAriaLabelToDisabledPaymentMethods();
    focusAccessibleAlert();
    sendEventToAdobeForRivertyMigration();
  }
};

function initPrepaymentModalForEditPayment() {
  $('#prePayOption .js-show-vk-popup a').click(function (e) {
    e.preventDefault();
    e.stopPropagation();
    modal.openModal($('.js-vk-boxmodal'));
  });
}

function handleEditPaymentSubmissionForZppAdyen() {
  if (window.Payment && window.Payment.saveAdyenCreditCard) {
    window.Payment.saveAdyenCreditCard();
  } else {
    $('form[id=payment-form]').submit();
  }
}

function handleEditPaymentSubmissionForZppBancontactAdyen() {
  if (window.Payment && window.Payment.saveBancontactAdyenCreditCard) {
    window.Payment.saveBancontactAdyenCreditCard();
  } else {
    $('form[id=payment-form]').submit();
  }
}

function handleEditPaymentSubmissionForZppBraintree() {
  if (window.Payment && window.Payment.braintreeTokenizeCard) {
    window.Payment.braintreeTokenizeCard()
      .then((result) => {
        if (!result.redirect) {
          document.getElementsByClassName('js-braintreeNonce')[0].value =
            result.data.nonce;
          document.getElementsByClassName(
            'js-braintreeCardholderName'
          )[0].value = result.data.details.cardholderName;
          document.getElementsByClassName('js-braintreeCardType')[0].value =
            result.data.details.cardType.toLowerCase();
          document.getElementsByClassName(
            'js-braintreeExpirationMonth'
          )[0].value = result.data.details.expirationMonth;
          document.getElementsByClassName(
            'js-braintreeExpirationYear'
          )[0].value = result.data.details.expirationYear;
          document.getElementsByClassName(
            'js-braintreeLastFourNumber'
          )[0].value = result.data.details.lastFour;
          document.getElementsByClassName('js-braintreeBinData')[0].value =
            result.data.binData;
          document.getElementsByClassName('js-braintreeBin')[0].value =
            result.data.details.bin;
          document.getElementsByClassName('js-braintreeStoreCard')[0].value =
            result.data.storeInVault;
        }
        $('form[id=payment-form]').submit();
      })
      .catch((error) => {
        logException(error, { area: 'braintree' });
        document
          .getElementById('editPaymentSubmit')
          .classList.remove('z-btn--loading', 'js-loading-btn');
      });
  } else {
    logError(
      'EditPayment - Cannot tokenize with Braintree as the function braintreeTokenizeCard is not available'
    );
  }
}

function getElementValue(element, elementName) {
  if (element === 'paymentMethod') {
    return $(`input[name='${element}']:checked`, elementName).val();
  } else {
    return $(`input[name='${elementName}']`).val();
  }
}

function showCreditCardActionInfoMessage() {
  $('.accordion__panel input[type="radio"]').on('click', function (e) {
    const selectedPaymentMethod = e.currentTarget.value;
    const creditCartMethodType = ['AK', 'BK'];
    if (!creditCartMethodType.includes(selectedPaymentMethod)) {
      $('.creditCardActionInfo').addClass('hide');
    } else {
      $('.creditCardActionInfo').removeClass('hide');
    }
  });
}

function selectOnlineBankingIssuerIssuer() {
  // preselect issuer
  let issuerId = $('#onlineBankingPlIssuerId').attr('value');
  $('.js-onlinebankingplIssuer[data-issuer-id="' + issuerId + '"]')
    .addClass('payment__issuer__selected')
    .attr('data-zta', 'selectedOnlineBankingPlIssuer');

  let onlineBankingIssuers = $('.js-onlinebankingplIssuer');
  // react on click
  onlineBankingIssuers.click(function () {
    selectOnlineBankingIssuerElement(this);
  });

  onlineBankingIssuers.keypress(function (e) {
    if (e.keyCode === 13) {
      selectOnlineBankingIssuerElement(e.currentTarget);
    }
  });
}

function selectOnlineBankingIssuerElement(elem) {
  $('.js-onlinebankingplIssuer')
    .removeClass('payment__issuer__selected')
    .attr('data-zta', '');
  $(elem)
    .addClass('payment__issuer__selected')
    .attr('data-zta', 'selectedOnlineBankingPlIssuer');
  $('#onlineBankingPlIssuerId').attr('value', $(elem).attr('data-issuer-id'));
  $('#onlineBankingPlIssuerName').attr(
    'value',
    $(elem).attr('data-issuer-name')
  );
}

function showHiddenBLZPayment() {
  $('#switchToBLZ').click(function (event) {
    event.preventDefault();
    toggleSepaBlz('BLZ');
  });
}

function showHiddenSepaPayment() {
  $('#switchToSepa').click(function (event) {
    event.preventDefault();
    toggleSepaBlz('Sepa');
  });
}

function disablePaymentMethodsDisabledByBrowser() {
  if (!ApplePayUtils.isEnabled()) {
    // For accordion design
    const applePayMethodElement = document.getElementById('applePayOption');
    const applePayMethodInput = document.getElementById('applePay');
    if (applePayMethodElement) {
      applePayMethodElement.classList.add('accordion__disabled');
      applePayMethodElement.classList.remove('active');
      if (applePayMethodInput) {
        applePayMethodInput.classList.add('radio__disabled');
        applePayMethodInput.disabled = true;
        applePayMethodInput.removeAttribute('checked');
      }
    }

    // For tab design
    const applePayTabElement = document.getElementById('applePayTab');
    if (applePayTabElement) {
      applePayTabElement.classList.add('disabled');
      applePayTabElement.classList.remove('active');
      const tabInput = applePayTabElement.querySelector('input[type="radio"]');
      if (tabInput) {
        tabInput.disabled = true;
        tabInput.removeAttribute('checked');
      }
    }
  }
}

function toggleSepaBlz(show) {
  let tempScrollTop = $(window).scrollTop();

  let $blzPanel = $('#bankTransferOption');
  let $blzRadio = $('#bankTransfer');
  let $sepaPanel = $('#sepaTransferOption');
  let $sepaRadio = $('#sepaTransfer');

  let $sepaOwner = $('input[data-identifier="bankPayment_ownerName_sepa"]');
  let $blzOwner = $('input[data-identifier="bankPayment_ownerName_blz"]');

  if (show === 'BLZ') {
    $sepaPanel.css('display', 'none');
    $sepaRadio.removeAttr('checked');

    activateOnePanel($blzPanel);
    $blzPanel.fadeIn();
    $blzRadio.prop('checked', true);
    $blzOwner.val($sepaOwner.val());
  }
  if (show === 'Sepa') {
    $blzPanel.css('display', 'none');
    $blzRadio.removeAttr('checked');

    activateOnePanel($sepaPanel);
    $sepaPanel.fadeIn();
    $sepaRadio.prop('checked', true);
    $sepaOwner.val($blzOwner.val());
  }

  $(window).scrollTop(tempScrollTop);
}

function activateOnePanel($formSelector) {
  let $content = isMyAccount
    ? $formSelector.find('.main__wrapper__account .panel__content')
    : $formSelector.find('.main__wrapper .panel__content');

  $formSelector.addClass('active');
  $formSelector
    .find('select, input')
    .not('input[type=radio]')
    .attr('disabled', false);
  $('.js-paymentType .accordion__panel')
    .not($formSelector)
    .removeClass('active')
    .find('select, input')
    .not('input[type=radio]')
    .attr('disabled', true);

  $content.show();
}

/* Masks the IBAN field */
function maskIban() {
  let el = document.querySelector('input[name="bankPayment.iban"]');
  //  There are issues for older android devices, so we don't activate masking for them.
  let isAndroid = utils.isAndroid();
  if (!isAndroid) {
    if (el && el.value.indexOf('*') === -1) {
      VMasker(el).maskPattern('SSSS SSSS SSSS SSSS SSSS SSSS SSSS SSSS');
    }
  }
}
/* Unmasks the IBAN field before submitting */
function clearMask() {
  let el = document.querySelector('input[name="bankPayment.iban"]');
  if (el) {
    let trimmedValue = el.value.toString().split(' ').join('');
    el.value = trimmedValue.toUpperCase();
  }
}

function trackInsecurePaymentMethodsMessage() {
  $('div[data-zta="insecurePaymentMethodsMessage"]').length !== 0 &&
    sendAdobeData(
      'customClickTrack',
      'Checkout',
      'Checkout:fraud',
      'InsecurePaymentMethodsMessageDisplayed'
    );
}

function showApplePayMessage() {
  if (!ApplePayUtils.isEnabled()) {
    const messageElement = document.getElementsByClassName(
      'browserNotSupportedMsg'
    )[0];
    if (messageElement !== undefined) {
      messageElement.style.display = 'inline-block';
    }
  }
}

function trackSepaErrors() {
  const { trackingError, trackIbanError, hostedPageIdError } =
    window.trackingDataErrors || {};

  window.addEventListener('load', () => {
    const trackDataLayer = [];
    const eventName = 'payment_tracking';

    if (trackingError && trackingError.isTrackError) {
      trackDataLayer.push({
        eventName,
        payload: {
          type: trackingError.errorType,
          error: trackingError.defaultErrorMessage,
        },
      });
    }

    if (trackIbanError && trackIbanError.isTrackError) {
      trackDataLayer.push({
        eventName,
        payload: {
          type: trackIbanError.errorType,
          error: trackIbanError.defaultErrorMessage,
        },
      });
    }

    if (hostedPageIdError) {
      trackDataLayer.push({
        eventName,
        payload: { type: 'HPP_ID_not_retrieved' },
      });
    }

    trackDataLayer.forEach((trackData) => {
      if (isAdobeSatelliteTrackingReady()) {
        _satellite.track(trackData.eventName, trackData.payload);
      }
    });
  });
}

function initPaymentTabs() {
  const tabsContainer = document.querySelector('.payment__tabs__container');
  if (!tabsContainer) return;

  const paymentTabs = [
    ...tabsContainer.querySelectorAll('.payment__tab:not(.disabled)'),
  ];
  if (!paymentTabs.length) return;

  const activateTab = (tab) => {
    if (!tab) return;

    const radioInput = tab.querySelector('input[type="radio"]');
    if (!radioInput || radioInput.disabled) return;

    radioInput.checked = true;

    paymentTabs.forEach((pTab) => {
      pTab.classList.remove('active');
      pTab.classList.add('inactive');
    });
    tab.classList.add('active');
    tab.classList.remove('inactive');

    const paymentContents = document.querySelectorAll('.payment__content');
    paymentContents.forEach((content) => content.classList.remove('active'));

    const contentId = tab.getAttribute('data-payment-content');
    const contentElement = document.getElementById(contentId);
    if (contentElement) {
      contentElement.classList.add('active');
    }
  };

  paymentTabs.forEach((tab) => {
    tab.addEventListener('click', () => activateTab(tab));
  });

  const checkedTab = paymentTabs.find((tab) =>
    tab.querySelector('input[type="radio"]:checked')
  );

  if (checkedTab) {
    activateTab(checkedTab);
  }
}

function initVkModalForModernisedPayment() {
  const $vkPopupLink = $('.payment__content .js-show-vk-popup a');

  if ($vkPopupLink.length > 0) {
    $vkPopupLink.click(function (e) {
      e.preventDefault();
      e.stopPropagation();
      modal.openModal($('.js-vk-boxmodal'));
    });
  }
}

function sendEventToAdobeForRivertyMigration() {
  const migrationMessage = document.querySelector('.migrationMessageRiverty');
  if (!migrationMessage) return;

  const interval = setInterval(() => {
    if (typeof window.SendAdobeData === 'function') {
      window.SendAdobeData(
        'customClickTrack',
        'Checkout',
        'Checkout:riverty',
        'RivertyMigrationMessageDisplayed'
      );
      clearInterval(interval);
    }
  }, 1000);
}

export default PAYMENT;
